import Spinner from "@/components/Ui/Spinner";
import { Button as ShadcnButton } from "@/components/shadcn/button";
import { ButtonHTMLAttributes, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

export type ButtonProps = {
  className?: string;
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  size?: "xs" | "sm" | "base" | "lg";
  disabled?: boolean;
  isLoading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement> & { target?: string };

const Button = ({
  children,
  className = "",
  variant = "default",
  size = "base",
  disabled = false,
  isLoading = false,
  ...rest
}: PropsWithChildren<ButtonProps>) => {
  return (
    <ShadcnButton
      disabled={disabled}
      variant={variant}
      className={twMerge("relative", className)}
      {...rest}
    >
      <span
        className={twMerge(
          "flex items-center justify-center space-x-2",
          isLoading && "opacity-0",
        )}
      >
        {children}
      </span>
      {isLoading && (
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
          <Spinner
            className={twMerge(
              size === "sm" && "text-base",
              size === "base" && "text-2xl",
              size === "lg" && "text-3xl",
            )}
          />
        </span>
      )}
    </ShadcnButton>
  );
};

export default Button;
